<template>
    <v-card dark class="mt-1">
            <v-card-actions>
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-on="on" v-bind="attrs" light small @click="$emit('changeHeader')" :disabled="disableChangeHeader">
                  <v-icon small left>mdi-table-edit</v-icon>
                  <span class="text-overline px-1">{{$t('labels.cabecalho')}}</span>
                </v-btn>
              </template>
              <span>{{$t('hints.cabecalho')}}</span>
            </v-tooltip>

            <v-spacer />
            <div>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs}">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="$emit('search')"
                        @shortkey="$emit('search')"
                        v-shortkey.once="['f1']"
                        small
                        color="info">
                        <v-icon small>mdi-magnify</v-icon>
                        <span class="px-1 text-overline">
                            {{$t('labels.buscar')}}
                        </span>
                    </v-btn>
                </template>
                {{$t('hints.buscar')}} [F1]
            </v-tooltip>
            </div>
            <div class="ml-1">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs}">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="$emit('register')"
                        @shortkey="$emit('register')"
                        v-shortkey.once="['alt', 'r']"
                        small
                        color="success">
                        <v-icon small>mdi-plus</v-icon>
                        <span class="px-1 text-overline">
                            {{$t('labels.novo')}}
                        </span>
                    </v-btn>
                </template>
                {{$t('hints.novo')}} [ALT + R]
            </v-tooltip>
            </div>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props:{
        disableChangeHeader:{
            default: false,
            required:false,
            type: Boolean
        }
    }
}
</script>